import axios from "../axios/axios";
import Pusher from "pusher-js";
import { pusher } from "./pusher";

const subscribedChannels = new Set<string>();

const subscribeChannel = (
  socket: Pusher,
  channelName: string,
  token: string
) => {
  if (!socket) {
    return;
  }

  if (subscribedChannels.has(channelName)) {
    return;
  }
  subscribedChannels.add(channelName);

  socket.connection.bind("pusher:connection_established", async (data: any) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_ENDPOINT}/api/pusher/manager/auth`,
        {
          socket_id: data.socket_id,
          channel_name: channelName,
        },
        {
          headers: { token },
        }
      );
    } catch (err) {
      console.error("Socket auth failed:", err);
    }
  });

  socket.subscribe(channelName);
};

const unsubscribeChannel = (socket: Pusher, channelName: string) => {
  if (!socket) {
    return;
  }
  socket.unsubscribe(channelName);
  subscribedChannels.delete(channelName);
};

export const authenticateSocket = (
  token: string,
  store_id: string,
  isLoggedIn: boolean,
  channel_name: string,
  isOnline: boolean
) => {
  const socket = pusher(token, store_id);
  if (!socket) {
    return;
  }

  const fullChannelName = `${channel_name}.${store_id}`;

  if (isLoggedIn && store_id && isOnline) {
    subscribeChannel(socket, fullChannelName, token);
  } else {
    unsubscribeChannel(socket, fullChannelName);
  }
};
